import { Dialog } from "@headlessui/react";
import React, { useState, useEffect } from "react";
import foto1 from '../../src/components/assets/images/galery1/foto1.jpg';
import foto2 from '../../src/components/assets/images/galery1/foto2.jpg';
import foto3 from '../../src/components/assets/images/galery1/foto3.jpg';
import foto4 from '../../src/components/assets/images/galery1/foto4.jpg';
import foto5 from '../../src/components/assets/images/galery1/foto5.jpg';
import foto6 from '../../src/components/assets/images/galery1/foto6.jpg';
import foto7 from '../../src/components/assets/images/galery1/foto7.jpg';
import foto8 from '../../src/components/assets/images/galery1/foto8.jpg';

const GalleryCE = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const images = [
    foto1,
    foto2,
    foto3,
    foto4,
    foto5,
    foto6,
    foto7,
    foto8
  ];

  const openImage = (index) => {
    setSelectedImage(images[index]);
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeImage = () => {
    setIsOpen(false);
    setSelectedImage(null);
    setCurrentIndex(null);
  };

  const showNextImage = () => {
    if (currentIndex < images.length - 1) {
      setSelectedImage(images[currentIndex + 1]);
      setCurrentIndex(currentIndex + 1);
    }
  };

  const showPreviousImage = () => {
    if (currentIndex > 0) {
      setSelectedImage(images[currentIndex - 1]);
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleKeydown = (event) => {
    if (event.key === "Escape") {
      closeImage();
    }
    if (event.key === "ArrowRight") {
      showNextImage();
    }
    if (event.key === "ArrowLeft") {
      showPreviousImage();
    }
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener("keydown", handleKeydown);
    } else {
      window.removeEventListener("keydown", handleKeydown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, [isOpen, currentIndex]);

  return (
    <div className="bg-gray-100 py-8">
      <div className="max-w-7xl mx-auto px-4">
        {/* Gallery Title */}
        <div className="text-center mb-8">
          <h2 className="text-3xl font-extrabold text-gray-800">
            Nuestra Galeria de Eventos
          </h2>
          <p className="text-gray-600 mt-2">
            Te presentamos nuestros eventos que organiza o participa Cevatur
          </p>
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {images.map((src, index) => (
            <div
              key={index}
              className="relative group overflow-hidden rounded-lg shadow-md cursor-pointer"
              onClick={() => openImage(index)}
            >
              <img
                src={src}
                alt={`Image ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </div>
          ))}
        </div>

        {/* Fullscreen Modal */}
        {isOpen && (
          <Dialog
            open={isOpen}
            onClose={closeImage}
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
          >
            <div className="relative">
              <img
                src={selectedImage}
                alt="Fullscreen"
                className="max-w-full max-h-screen rounded-lg"
              />
              <button
                onClick={closeImage}
                className="absolute top-4 right-4 text-white text-2xl font-bold"
              >
                ✕
              </button>

              {/* Navigation Buttons */}
              <button
                onClick={showPreviousImage}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl font-bold"
              >
                ←
              </button>
              <button
                onClick={showNextImage}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl font-bold"
              >
                →
              </button>
            </div>
          </Dialog>
        )}
      </div>
    </div>
  );
};

export default GalleryCE;
